import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import './NewStyle.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row, Modal, Button } from "react-bootstrap"; // ✅ Added Modal & Button
import useAuth from "../../hooks/useAuth";
import { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import customFont from './NotoSansMalayalam-VariableFont_wdth,wght-normal.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes, faInfoCircle, faBlackboard, } from "@fortawesome/free-solid-svg-icons";


const AdminListGurudakshinaInSthan = () => {
  const { auth } = useAuth();

  const NAME_REGEX = /^(?!\s*$).+/;
  const MOBILE_REGEX = /^[0-9]{10}$/;
  const AMOUNT_REGEX = /^[0-9]$/;
  const ADD_GURUDAKSHINA_URL = "add-gurudakshina";
  const EDIT_GURUDAKSHINA_URL = "update-gurudakshina";
  const [sthanId, setsthanId] = useState(auth?.level_id); // default value



  const { Id, Name } = useParams();
  const [gurudakshinas, setGurudakshinas] = useState([]);
  const [gurudakshinaFinalizationStatus, setGurudakshinasFinalizationStatus] = useState([]);
  const [FinalSubmissionList, setFinalSubmissionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const gurudakshinaPerPage = 50;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  // For page filter
  const [selectedSakha, setSelectedSakha] = useState("");

  // For Add Gurudakshina popup
  const [addSakha, setAddSakha] = useState("");
  const [sakhaList, setSakhaList] = useState([]);

  const [proudaSubmitted, setProudaSubmitted] = useState(false);
  const [vidyarthiSamyukthaSubmitted, setVidyarthiSamyukthaSubmitted] = useState(false);
  const [vidyarthiTharunaSubmitted, setVidyarthiTharunaSubmitted] = useState(false);
  const [vyavasayiTharunaSubmitted, setVyavasayiTharunaSubmitted] = useState(false);
  const [Finilized, setFinilized] = useState([]);
  const [sakhaWarning, setSakhaWarning] = useState(false);
  const [selectedShreni, setSelectedShreni] = useState("");
  const [shreniList, setShreniList] = useState([]);
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const [age, setAge] = useState("");
  const [house_name, setHouse_name] = useState("");
  const [pan, setPan] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [chequeNo, setChequeNo] = useState("");
  const [pincode, setPincode] = useState("");

  const today = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"
  const [originalDate, setOriginalDate] = useState(today);
  const [postOffice, setPostOffice] = useState("");
  const nameRef = useRef();
  const mobileRef = useRef();
  const amountRef = useRef();
  const chequeNoRef = useRef();

  const [year, month, day] = originalDate.split("-");
  const formattedDate = `${day}/${month}/${year}`;

  useEffect(() => {
    nameRef.current?.focus();
  }, []);


  const [validMobile, setValidMobile] = useState(false);
  const [validName, setValidName] = useState(false);
  const [validAmount, setValidAmount] = useState(false);
  const [validChequeNo, setValidChequeNo] = useState(false);

  const [chequeNoFocus, setChequeNoFocus] = useState(false);
  const [amountFocus, setAmountFocus] = useState(false);
  const [mobileFocus, setMobileFocus] = useState(false);
  const [nameFocus, setNameFocus] = useState(false);

  const [sakhaSubmitted, setSakhaSubmitted] = useState("");

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const errRef = useRef();

  const [Sthans, setSthans] = useState([]);
  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");
  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");

  const [sthanList, setSthanList] = useState([]);
  const [selectedSthanId, setSelectedSthanId] = useState("");

  const [hasSearched, setHasSearched] = useState(false); // 👈 NEW

  const [showAddModal, setShowAddModal] = useState(false);
  const [gurudakshinaName, setGurudakshinaName] = useState("");

  const [sakhaError, setSakhaError] = useState("");
  const [selectedPopupSakha, setSelectedPopupSakha] = useState("");
  const [isCheque, setIsCheque] = useState(false);
  const [isStudent, setIsStudent] = useState(false);
  const [isPrathyajithVolunteer, setIsPrathyajithVolunteer] = useState(false);

  const [nameSuggestions, setNameSuggestions] = useState([]);
  const [showNameSuggestions, setShowNameSuggestions] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [studentDisabled, setStudentDisabled] = useState(false);


  const [postOfficeSuggestions, setPostOfficeSuggestions] = useState([]);
  const [pincodeSuggestions, setPincodeSuggestions] = useState([]);

  const [showPostOfficeDropdown, setShowPostOfficeDropdown] = useState(false);
  const [showPincodeDropdown, setShowPincodeDropdown] = useState(false);

  const [submittedData, setSubmittedData] = useState("");

  const [gurudakshinaId, setGurudakshinaId] = useState("");
  const [searchName, setSearchName] = useState("");
  const [debouncedSearchName, setDebouncedSearchName] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchName(searchName);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [searchName]);


  const getShreni = (age) => {
    const ageNum = Number(age);

    if (ageNum > 40) {
      return "Prouda";
    } else if (ageNum >= 16) {
      return "Tharuna";
    } else if (ageNum >= 11) {
      return "Bala";
    } else {
      return "Sisu";
    }
  };

  const updateStudentStatus = (age) => {
    const ageNum = Number(age);

    if (ageNum >= 0 && ageNum <= 2) {
      // 0-2: Disabled, Unchecked
      setIsStudent(false);
      setStudentDisabled(true);
    } else if (ageNum >= 3 && ageNum <= 15) {
      // 3-15: Disabled, Checked
      setIsStudent(true);
      setStudentDisabled(true);
    } else if (ageNum >= 16 && ageNum <= 40) {
      // 16-40: Enabled, Unchecked
      setIsStudent(false);
      setStudentDisabled(false);
    } else if (ageNum > 40) {
      // 40+: Disabled, Unchecked
      setIsStudent(false);
      setStudentDisabled(true);
    } else {
      // No age entered
      setIsStudent(false);
      setStudentDisabled(false);
    }
  };


  const resetAddForm = () => {
    setAddSakha("");
    setSelectedShreni("");
    setName("");
    setMobile("");
    setAmount("");
    setAge("");
    setHouse_name("");
    setPan("");
    setSelectedPaymentMode("");
    setSelectedBank("");
    setChequeNo("");
    setPincode("");
    setPostOffice("");
    setOriginalDate(new Date().toISOString().split('T')[0]);
    setFinilized(false);
    setSakhaWarning(false);
    setErrMsg("");
    setSucssMsg("");
  };

  const searchPincode = async (value) => {
    if (value.length < 2) {
      setPincodeSuggestions([]);
      return;
    }

    try {
      const res = await axiosPrivate.get(`get-post-office?pincode=${value}`);
      setPincodeSuggestions(res.data || []);
      setShowPincodeDropdown(true);
    } catch (err) {
      setPincodeSuggestions([]);
    }
  };


  const searchPostOffice = async (value) => {
    if (value.length < 2) {
      setPostOfficeSuggestions([]);
      return;
    }

    try {
      const res = await axiosPrivate.get(
        `get-post-office?office=${encodeURIComponent(value)}`
      );

      setPostOfficeSuggestions(res.data || []);
      setShowPostOfficeDropdown(true);
    } catch (err) {
      setPostOfficeSuggestions([]);
    }
  };

  // const handleOpenAddModal = () => {
  //   resetAddForm();

  //   if (selectedSakha) {
  //     setAddSakha(selectedSakha);
  //     handleAddSakhaChange(selectedSakha);
  //   }

  //   setShowAddModal(true);
  // };

  const handleOpenAddModal = async () => {
    if (!selectedSakha) {
      setSakhaError("Please select Ultsavam.");
      return;
    }

    setSakhaError("");

    await fetchFinalSubmissionList();
    setGurudakshinaId("");

    clearFields();

    setShowAddModal(true);
  };

  const clearFields = async () => {

    setGurudakshinaId("");   // Important

    setSelectedPopupSakha("");
    setSelectedShreni("");
    setName("");
    setMobile("");
    setAmount("");
    setPan("");
    // setSelectedPaymentMode("");
    setIsCheque("");
    setSelectedBank("");
    setChequeNo("");
    setHouse_name("");
    setPincode("");
    setPostOffice("");
    setFinilized(false);
    setSakhaWarning(false);
    setAge("");
    setIsStudent("");
    setIsPrathyajithVolunteer("");


  };


  const handleCloseAddModal = () => {
    setShowAddModal(false);
    setGurudakshinaName("");
  };

  useEffect(() => {
    const isValid = /^(?!.*\d).{2,}$/.test(name);
    // (?!.*\d) → negative lookahead, ensures no digits 0–9
    // .{2,}    → any 2 or more characters (except newlines)
    setValidName(isValid);
  }, [name]);


  const handleAddSakhaChange = (value) => {
    setAddSakha(value);

    let finalizedValue = false;

    if (value === "Prouda") {
      finalizedValue = proudaSubmitted;
    } else if (value === "Vidyarthi Samyuktha") {
      finalizedValue = vidyarthiSamyukthaSubmitted;
    } else if (value === "Vidyarthi Tharuna") {
      finalizedValue = vidyarthiTharunaSubmitted;
    } else if (value === "Vyavasayi Tharuna") {
      finalizedValue = vyavasayiTharunaSubmitted;
    }

    setFinilized(finalizedValue);
    setSakhaWarning(finalizedValue);
  };


  const fetchPaymentMode = async () => {
    try {
      // Uncomment this when using real API:
      // const res = await axios.get('API_URL/list-PaymentMode');
      // setShreniList(res.data);

      // Mock data if API fails or during development:
      setPaymentModeList([
        "Cheque",
        "Cash",
      ]);
    } catch (err) {
      console.error("Failed to fetch Payment Modes", err);
      // fallback data on error
      setPaymentModeList([
        "Cheque",
        "Cash",
      ]);
    }
  };

  useEffect(() => {
    fetchPaymentMode();
  }, []);

  useEffect(() => {
    fetchSakhaList();
  }, []);
  useEffect(() => {
    fetchShreniList();
  }, []);

  const fetchShreniList = async () => {
    try {
      // Uncomment this when using real API:
      const res = await axiosPrivate.get('get-shrenies');
      setShreniList(res.data);

    } catch (err) {
      console.error("Failed to fetch Shreni", err);
      // fallback data on error
    }
  };

  const handleSakhaChange = (e) => {
    const value = e.target.value;

    setSelectedPopupSakha(value);

    let finalizedValue = false;

    if (value === "Prouda") {
      finalizedValue = proudaSubmitted;
    } else if (value === "Vidyarthi Samyuktha") {
      finalizedValue = vidyarthiSamyukthaSubmitted;
    } else if (value === "Vidyarthi Tharuna") {
      finalizedValue = vidyarthiTharunaSubmitted;
    } else if (value === "Vyavasayi Tharuna") {
      finalizedValue = vyavasayiTharunaSubmitted;
    }

    setFinilized(finalizedValue);
    setSakhaWarning(finalizedValue === true);
  };


  // const handleSakhaChange = (e) => {
  //   const value = e.target.value;
  //   setSelectedSakha(value); // still async, but we use `value` below

  //   let finalizedValue = false;

  //   if (value === "Prouda") {
  //     finalizedValue = proudaSubmitted;
  //   } else if (value === "Vidyarthi Samyuktha") {
  //     finalizedValue = vidyarthiSamyukthaSubmitted;
  //   } else if (value === "Vidyarthi Tharuna") {
  //     finalizedValue = vidyarthiTharunaSubmitted;
  //   } else if (value === "Vyavasayi Tharuna") {
  //     finalizedValue = vyavasayiTharunaSubmitted;
  //   }

  //   setFinilized(finalizedValue); // still update your state
  //   setSakhaWarning(finalizedValue === true);
  // };

  useEffect(() => {
    const fetchSthanList = async () => {
      if (!selectedKhandId) {
        setSthanList([]);
        setSelectedSthanId("");
        // setSthans([]); // clear table
        return;
      }


      try {
        const res = await axiosPrivate.get(`list-sthans?mandal_id=${selectedMandalamId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setSthanList(data);
        if (data.length > 0) {
          const firstSthanId = data[0].sthan_id;
          setSelectedSthanId("");  // force change
          setTimeout(() => {
            setSelectedSthanId(firstSthanId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedSthanId("");
          // setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setSthanList([]);
        setSelectedSthanId("");
        // setSthans([]);
      }
    };

    fetchSthanList();
  }, [selectedMandalamId]);



  const fetchKhands = useCallback(async () => {
    if (!auth.level_id) return;


    // setSthans([]);
    try {
      const res = await axiosPrivate.get(`list-khands-in-arthik-sakha?arthik_sakha_id=${auth.level_id}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);
      if (data.length > 0) {
        setSelectedKhandId(data[0].khand_id); // optional default
      } else {
        setSelectedKhandId("");
      }
    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    }
  }, [axiosPrivate, auth.level_id]);

  useEffect(() => {
    if (auth.level_id) {
      fetchKhands();
    }
  }, [auth.level_id]);

  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        // setSthans([]); // clear table
        return;
      }


      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          // setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load mandals list");
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]);
      }
    };

    fetchMandalamList();
  }, [selectedKhandId]);



  // ✅ Modal state
  const [showFinalizeModal, setShowFinalizeModal] = useState(false);
  const [ShowFinalConfirmModal, setShowFinalConfirmModal] = useState(false);
  const handleCloseModal = () => setShowFinalizeModal(false);

  const handleShowModal = async () => {

    if (!selectedSakha) {
      setSakhaError("Please select Ultsavam.");
      return;
    }

    setSakhaError("");

    try {
      const response = await fetchFinalSubmissionList(); // your API function
      setShowFinalizeModal(true); // Open modal after success
    } catch (error) {
      console.error("Failed to fetch finalize data:", error);
      // Optionally show error toast or alert here
    }
  };

  // const ClickAddGurudakshina = () => {
  //   navigate(`/arthikShakha/add/gurudakshina/${selectedSthanId}`);
  // };
  const handleFinalize = () => {
    setShowFinalizeModal(false);    // Close first modal
    setShowFinalConfirmModal(true);       // Show second confirmation modal
  };

  const handleCloseSecondModal = () => setShowFinalConfirmModal(false);

  const fetchSakhaList = async () => {
    try {
      const res = await axiosPrivate.get('get-sakhas');
      setSakhaList(res.data);
    } catch (err) {
      console.error("Failed to fetch sakhas", err);
    }
  };

  useEffect(() => {
    fetchSakhaList();
  }, []);



  // const fetchgurudakshina = useCallback(async () => {
  //   if (!selectedSthanId) return;  // 🛑 Prevent API call if undefined or empty
  //   setLoading(true);
  //   setHasSearched(true)
  //   setError(null);
  //   try {
  //     // Construct the URL first
  //     // const url = `list-gurudakshina?sthan_id=${selectedSthanId}${selectedSakha ? `&sakha=${selectedSakha}` : ''}`;
  //     const url =
  //       `list-gurudakshina?sthan_id=${selectedSthanId}${selectedSakha ? `&sakha=${selectedSakha}` : ''
  //       }&orderby=desc`;

  //     const response = await axiosPrivate.get(url, { withCredentials: true });
  //     setGurudakshinas(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching Data:", error);
  //     setError(error?.response?.data?.message || "No Data available.");
  //     setLoading(false);
  //   }
  // }, [axiosPrivate, selectedSakha, selectedSthanId]);

  const fetchgurudakshina = useCallback(async () => {
    // Prevent API call if no Sthan is selected
    if (!selectedSthanId) return;

    setError(null);
    setLoading(true);
    setHasSearched(true);
    setGurudakshinas([]);   // Clear previous data

    try {
      // Construct API URL
      // const url = `list-gurudakshina?sthan_id=${selectedSthanId}${selectedSakha ? `&sakha=${selectedSakha}` : ''
      //   }`;

      // const url = `list-gurudakshina?sthan_id=${selectedSthanId}${selectedSakha ? `&sakha=${encodeURIComponent(selectedSakha)}` : ""
      //   }${searchName.trim() ? `&name=${encodeURIComponent(searchName.trim())}` : ""
      //   }`;

      const url = `list-gurudakshina?new_entry=1&sthan_id=${selectedSthanId}${selectedSakha ? `&sakha=${encodeURIComponent(selectedSakha)}` : ""
        }${debouncedSearchName.trim()
          ? `&name=${encodeURIComponent(debouncedSearchName.trim())}`
          : ""
        }`;

      const response = await axiosPrivate.get(url, {
        withCredentials: true,
      });

      const sortedData = [...response.data].sort((a, b) => b.id - a.id);

      setGurudakshinas(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);

      setError(
        error?.response?.data?.message || "No data available."
      );
    } finally {
      setLoading(false);
    }
    // }, [axiosPrivate, selectedSakha, selectedSthanId]);
    // }, [axiosPrivate, selectedSakha, selectedSthanId, searchName]);
  }, [axiosPrivate, selectedSakha, selectedSthanId, debouncedSearchName]);



  useEffect(() => {
    fetchgurudakshina();
  }, [fetchgurudakshina]);

  const fetchGurudakshinaFinalizationStatus = useCallback(async () => {
    if (!selectedSthanId || !selectedSakha) {
      // console.log("Skipping fetch: Missing selectedSthanId or selectedSakha", { selectedSthanId, selectedSakha });
      setGurudakshinasFinalizationStatus(null); // 🧹 Clear old data
      return;
    }

    setError(null);
    try {
      const response = await axiosPrivate.get(
        `gurudakshina-finalization-status?sthan_id=${selectedSthanId}&sakha=${selectedSakha}`,
        { withCredentials: true }
      );
      setGurudakshinasFinalizationStatus(response.data);


    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");

    }
  }, [axiosPrivate, selectedSakha, selectedSthanId]);


  const searchGurudakshinaByName = async (value) => {
    if (value.trim().length < 2 || !selectedSthanId) {
      setNameSuggestions([]);
      setShowNameSuggestions(false);
      return;
    }

    try {
      const res = await axiosPrivate.get(
        `list-gurudakshina?sthan_id=${selectedSthanId}&new_entry=0&name=${encodeURIComponent(value)}`
      );

      setNameSuggestions(res.data || []);
      setShowNameSuggestions(true);
    } catch (err) {
      setNameSuggestions([]);
      setShowNameSuggestions(false);
    }
  };


  useEffect(() => {
    const timer = setTimeout(() => {
      searchGurudakshinaByName(name);
    }, 300);

    return () => clearTimeout(timer);
  }, [name, selectedSthanId]);





  const fetchFinalSubmissionList = useCallback(async () => {
    setError(null);
    try {
      const response = await axiosPrivate.get(`list-final-submissions?sthan_id=${selectedSthanId}`, {
        withCredentials: true,
      });

      const data = response.data;
      setFinalSubmissionList(data);


      data.forEach(item => {
        switch (item.sakha) {
          case "Prouda":
            setProudaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          case "Vidyarthi Samyuktha":
            setVidyarthiSamyukthaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          case "Vidyarthi Tharuna":
            setVidyarthiTharunaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          case "Vyavasayi Tharuna":
            setVyavasayiTharunaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          default:
            break;
        }
      });

    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");

    }
  }, [axiosPrivate, selectedSthanId]);

  useEffect(() => {
    if (selectedSthanId) {
      fetchFinalSubmissionList();
    }
  }, [selectedSthanId, fetchFinalSubmissionList]);




  const AddGurudakshinaSubmit = async (e) => {
    e.preventDefault();
    try {
      var data = JSON.stringify({
        sthan_id: selectedSthanId,
        name,
        sakha: addSakha,
        shreni: selectedShreni,
        amount,
        age,
        payment_mode: selectedPaymentMode,
        mobile: mobile,
        cheque_no: chequeNo,
        bank: selectedBank,
        house_name,
        date_of_samarppan: formattedDate,
        pan: pan,
        pincode: pincode,
        post_office: postOffice
      });

      const response = await axiosPrivate.post(ADD_GURUDAKSHINA_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchgurudakshina();
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current.focus();
    }


  };


  useEffect(() => {
    fetchgurudakshina();
    fetchGurudakshinaFinalizationStatus();
  }, [selectedSakha, selectedSthanId]);



  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // clear success message
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // clear error message
      setShowSuccessModal(true); // Show modal

      // Auto close after 10 seconds (10000 ms)
      setTimeout(() => {
        setShowSuccessModal(false);
      }, 5000);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitted(true);

    if (
      !originalDate ||
      !name.trim() ||
      !house_name.trim() ||
      // !selectedPopupSakha ||
      !selectedSakha ||
      !age ||
      !selectedShreni ||
      !mobile.trim() ||
      !amount.trim() ||
      !pincode.trim() ||
      !postOffice.trim() ||
      (parseFloat(amount) > 1999 && !pan.trim()) ||
      (isCheque && (!selectedBank.trim() || !chequeNo.trim()))
    ) {
      return;
    }

    if (!age || Number(age) < 1 || Number(age) > 110) {
      setErrMsg("Age must be between 1 and 110.");
      return;
    }

    try {
      var data = JSON.stringify({
        sthan_id: selectedSthanId,
        name,
        // sakha: selectedPopupSakha,
        sakha: selectedSakha,
        shreni: selectedShreni,
        amount,
        // payment_mode: selectedPaymentMode,
        payment_mode: isCheque ? "Cheque" : "Cash",
        mobile: mobile,
        cheque_no: chequeNo,
        bank: selectedBank,
        house_name,
        date_of_samarppan: formattedDate,
        pan: pan,
        pincode: pincode,
        post_office: postOffice,
        age: age,
        oauth_taken: isPrathyajithVolunteer,
        vidyarthi: isStudent
      });
      setSubmittedData(data);

      const response = await axiosPrivate.post(ADD_GURUDAKSHINA_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchgurudakshina();
      clearFields();
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current?.focus();
    }


  };


  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmittedData("");
      var data = JSON.stringify({
        id: gurudakshinaId,
        sthan_id: selectedSthanId,
        name,
        // sakha: selectedPopupSakha,
        sakha: selectedSakha,
        shreni: selectedShreni,
        amount,
        // payment_mode: selectedPaymentMode,
        payment_mode: isCheque ? "Cheque" : "Cash",
        mobile: mobile,
        cheque_no: chequeNo,
        bank: selectedBank,
        house_name,
        date_of_samarppan: formattedDate,
        pan: pan,
        pincode: pincode,
        post_office: postOffice,

        age: age,
        oauth_taken: isPrathyajithVolunteer,
        vidyarthi: isStudent
      });
      setSubmittedData(data);

      const response = await axiosPrivate.post(EDIT_GURUDAKSHINA_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchgurudakshina();
      clearFields();
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current?.focus();
    }


  };


  const finalSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = JSON.stringify({
        sthan_id: selectedSthanId,
        sakha: selectedSakha,
      });

      const response = await axiosPrivate.post(
        "update-final-submissions",
        data,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      showMessage("success", response?.data?.message);
      fetchGurudakshinaFinalizationStatus();

    } catch (err) {
      const errorMsg =
        !err.response
          ? "No Server Response"
          : err.response?.data?.message?.msg ||
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Finalization Failed";

      showMessage("error", errorMsg);
      alert(errorMsg);

    } finally {
      // This runs for both success and error
      setShowFinalConfirmModal(false)

    }
  };

  const indexOfLastGurudakshina = currentPage * gurudakshinaPerPage;
  const indexOfFirstGurudakshina = indexOfLastGurudakshina - gurudakshinaPerPage;
  const currentgurudakshinas = gurudakshinas.slice(indexOfFirstGurudakshina, indexOfLastGurudakshina);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(gurudakshinas.length / gurudakshinaPerPage);

  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  const [pdfGenerating, setPdfGenerating] = useState(false);
  const [selectedSthanName, setSelectedSthanName] = useState("");

  useEffect(() => {
    if (selectedSthanId && sthanList.length > 0) {
      const selectedItem = sthanList.find(
        (m) => String(m.sthan_id) === String(selectedSthanId)
      );
      if (selectedItem) {
        setSelectedSthanName(selectedItem.search_tag);
        console.log("selectedSthanName =", selectedItem.search_tag);
      }
    }
  }, [selectedSthanId, sthanList]);

  const exportPDF = async () => {
    if (pdfGenerating) return; // prevent multiple clicks
    if (!gurudakshinas || gurudakshinas.length === 0) {
      alert("No data available to generate PDF.");
      return;
    }

    setPdfGenerating(true);

    try {
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF();

      // Add Malayalam font
      doc.addFileToVFS("NotoSansMalayalam.ttf", customFont);
      doc.addFont("NotoSansMalayalam.ttf", "NotoSansMalayalam", "normal");
      doc.setFont("NotoSansMalayalam");

      // // Title
      // doc.text(selectedSthanName + " Sthan gurudakshina list", 14, 10);
      // doc.text("Gurudakshina for " + selectedSakha + " Ultsavam at " + selectedSthanName + " Sthan.", 14, 10);
      if (selectedSakha) {
        doc.setFontSize(12); // Smaller font
        doc.text(
          "Gurudakshina of " + selectedSakha + " Ultsavam at " + selectedSthanName + " Sthan.",
          14,
          10
        );
      } else {
        doc.setFontSize(16); // Original/larger font
        doc.text(
          selectedSthanName + " Sthan gurudakshina list",
          14,
          10
        );
      }



      // Table headers
      const headers = [[
        "Ultsavam - Shreni",
        "Name",
        "Address",
        "PAN",
        "Mobile",
        "Amount",
        "Samarppan date"
      ]];

      const data = gurudakshinas.map(g => [
        `${g.sakha} - ${g.shreni}`,
        g.name,
        `${g.house_name}, ${g.post_office} - ${g.pincode}`,
        g.pan,
        g.mobile,
        g.amount,
        (() => {
          if (!g.date_of_samarppan) return "";

          const [day, month, year] = g.date_of_samarppan.split("-");

          return new Date(`${year}-${month}-${day}`).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
        })()
      ]);

      // AutoTable
      doc.autoTable({
        head: headers,
        body: data,
        startY: 20,
        styles: { fontSize: 8, font: "NotoSansMalayalam" },
        headStyles: {
          font: "NotoSansMalayalam",
          fillColor: [0, 0, 0],
          textColor: [255, 255, 255],
          halign: "center"
        }
      });



      if (selectedSakha) {
        doc.save(
          `Gurudakshina of ${selectedSakha} Ultsavam at ${selectedSthanName} Sthan.pdf`
        );
      } else {
        doc.save(`${selectedSthanName} Sthan Gurudakshina List.pdf`);
      }
    } catch (error) {
      console.error("PDF Generation Error:", error);
      alert("Failed to generate PDF.");
    } finally {
      setPdfGenerating(false);
    }
  };

  return (
    <>
      <style>
        {`
        #customers td {
          text-align: left !important;
        }
      `}
      </style>
      <section className="empbody">
        <div className="wrapperemp2">
          {/* ✅ Finalize Button with Modal trigger */}



          <div className="d-flex justify-content-end align-items-center gap-2 mb-3">
            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
            {/* <button onClick={ClickAddGurudakshina} type="button" className="btn btn-success ms-auto newviewbtn">+ Gurudakshina</button>
            <button onClick={handleShowModal} type="button" className="btn btn-warning  newviewbtn">Finalize</button> */}

            {selectedSthanId && (
              <>
                <button
                  type="button"
                  className="btn btn-success newviewbtn"
                  onClick={exportPDF}
                  disabled={pdfGenerating} // ✅ prevent click while generating
                >
                  {pdfGenerating ? "Generating..." : "Download PDF"}
                </button>


                <button
                  onClick={handleOpenAddModal}
                  type="button"
                  className="btn btn-success ms-auto newviewbtn"
                >
                  + Gurudakshina
                </button>
                <button onClick={handleShowModal} type="button" className="btn btn-warning newviewbtn">
                  Finalize
                </button>
              </>
            )}

          </div>

          <h3>Gurudakshina List</h3>


          <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
            <Modal.Header closeButton>
              {/* <Modal.Title>Success</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <p>{sucssMsg}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setShowSuccessModal(false)}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
          <Row>



            <Col md={2}>
              <Form.Label className="newformstyle">Khand</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedKhandId}
                onChange={(e) => setSelectedKhandId(e.target.value)}
                disabled={!khandList.length}
              >
                <option value="">-- Select Khand --</option>
                {khandList.map((k) => (
                  <option key={k.khand_id} value={k.khand_id}>
                    {k.khand_name}
                  </option>
                ))}
              </Form.Select>

            </Col>

            <Col md={2}>
              <Form.Label className="newformstyle">Mandalam</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedMandalamId}
                onChange={(e) => {
                  const mandalamId = e.target.value;
                  setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID
                  // Remove this:
                  // setSelectedKhandId(khandId);
                  // setMandalamList([]);
                  // setSthans([]);
                }}
                disabled={!mandalamList.length}
              >

                <option value="">-- Select Mandalam --</option>
                {mandalamList.map((m) => (
                  <option key={m.mandal_id} value={m.mandal_id}>
                    {m.mandal_name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col md={2}>
              <Form.Label className="newformstyle">Sthan</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedSthanId}
                onChange={(e) => {
                  const sthanId = e.target.value;
                  setSelectedSthanId(sthanId); // Correctly set Mandalam ID
                  // Remove this:
                  // setSelectedKhandId(khandId);
                  // setMandalamList([]);
                  // setSthans([]);
                }}
                disabled={!sthanList.length}
              >

                <option value="">-- Select Sthan --</option>
                {sthanList.map((m) => (
                  <option key={m.sthan_id} value={m.sthan_id}>
                    {m.sthan_name}
                  </option>
                ))}
              </Form.Select>
            </Col>



            <Col md={2}>

              <Form.Group controlId="pranthDropdown" className="mb-3">
                <Form.Label className="newformstyle">Ultsavam</Form.Label>
                <Form.Control
                  as="select"
                  className="newregselect2"
                  value={selectedSakha}
                  //     onChange={(e) => setSelectedSakha(e.target.value);
                  // setSakhaError("");
                  //     }
                  onChange={(e) => {
                    setSelectedSakha(e.target.value);
                    setSakhaError("");
                  }}
                >
                  <option value="">-- Select Ultsavam --</option>
                  {sakhaList.map((sakha, index) => (
                    <option key={index} value={sakha}>{sakha}</option>
                  ))}
                </Form.Control>
              </Form.Group >
              {sakhaError && (
                <small className="text-danger d-block mt-1">
                  {sakhaError}
                </small>
              )}
            </Col>
            <Col md={2}>

              {/* <Col md={3}> */}
              <Form.Group controlId="pranthDropdown" className="mb-3">
                <Form.Label className="newformstyle">Search Name</Form.Label>

                <Form.Control
                  type="text"
                  className="newregselect2"
                  placeholder="Enter name"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                />
              </Form.Group>
              {/* </Col> */}
            </Col>


          </Row>


          <div className="table-container">
            <div className="newdivst">
              {gurudakshinaFinalizationStatus && gurudakshinaFinalizationStatus.sakha && (
                <Row>
                  <Col md={3}>
                    <p>Ultsavam : <span>{gurudakshinaFinalizationStatus.sakha}</span></p>
                  </Col>
                  <Col md={3}>
                    <p>Total Amount : <span>{gurudakshinaFinalizationStatus.amount}</span></p>
                  </Col>
                  <Col md={3}>
                    <p>Submitted Date : <span>{gurudakshinaFinalizationStatus.submitted_date}</span></p>
                  </Col>
                  <Col md={3}>
                    <p>Is Submitted : <span>{gurudakshinaFinalizationStatus.isSubmitted ? "Yes" : "No"}</span></p>
                  </Col>
                </Row>
              )}
            </div>
            {hasSearched && (
              <table id="customers">
                <thead>
                  <tr>
                    {/* <th>Id</th> */}
                    {/* <th>Ultsavam - Shreni</th>*/}
                    <th>Name</th>
                    <th>Age</th>
                    <th>Address</th>
                    <th>PAN</th>
                    <th>Mobile</th>
                    <th>Amount</th>
                    <th>Samarppan date</th>
                    <th>Options</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="16" className="text-center text-primary">
                        Loading...
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="16" className="text-danger text-center">{error}</td>
                    </tr>
                  ) : selectedSthanId && gurudakshinas.length === 0 ? (
                    <tr>
                      <td colSpan="16" className="text-center">No Data available.</td>
                    </tr>
                  ) : (
                    // currentgurudakshinas.map(gurudakshina => (
                    // [...currentgurudakshinas]
                    //     .sort((a, b) => b.date_of_samarppan - a.date_of_samarppan)
                    //     .map(gurudakshina => (
                    [...currentgurudakshinas]
                      .sort((a, b) => {
                        if (!a.date_of_samarppan) return 1;
                        if (!b.date_of_samarppan) return -1;

                        const [dayA, monthA, yearA] = a.date_of_samarppan.split("-");
                        const [dayB, monthB, yearB] = b.date_of_samarppan.split("-");

                        const dateA = new Date(`${yearA}-${monthA}-${dayA}`);
                        const dateB = new Date(`${yearB}-${monthB}-${dayB}`);

                        return dateB - dateA;
                      })
                      .map((gurudakshina) => (

                        <tr key={gurudakshina.date_of_samarppan}>
                          {/* <td >{gurudakshina.id}</td> */}
                          {/* <td>{gurudakshina.sakha} - {gurudakshina.shreni}</td> */}

                          <td >{gurudakshina.name}</td>
                          <td >{gurudakshina.age}</td>
                          <td >{gurudakshina.house_name},<br></br>
                            {gurudakshina.post_office} - {gurudakshina.pincode}</td>
                          <td>{gurudakshina.pan}</td>
                          <td>{gurudakshina.mobile}</td>
                          <td>{gurudakshina.amount}</td>
                          <td>
                            {gurudakshina.date_of_samarppan
                              ? new Date(
                                gurudakshina.date_of_samarppan.split("-").reverse().join("-")
                              ).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              : "-"}
                          </td>
                          <td>
                            <button type="button" className="btn btn-info btn-ico newicobtn newviewbtn" onClick={() => window.open(`/view/gurudakshina/${gurudakshina.id}`, '_blank')}>
                              <i className="bx bxs-show icon"></i>
                            </button>
                            {/* <button
                              type="button"
                              className="btn btn-warning btn-ico newicobtn newviewbtn"
                              onClick={() =>
                                window.open(`/admin/edit/gurudakshina/${gurudakshina.id}/${selectedSthanId}`, '_blank')
                              }
                            >
                              <i className="bx bxs-edit icon"></i>
                            </button> */}




                          </td>
                        </tr>
                      ))
                  )}
                </tbody>
              </table>
            )}
          </div>
          <div className="table-container">
            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </div >
      </section >

      <Modal show={showFinalizeModal} onHide={handleCloseModal} centered>
        <Modal.Body>
          <div className="modstyle">
            <center>
              <h6>Which you want to finalize?</h6>



              <table className="table table-bordered mt-3" id="customers">
                <thead>
                  <tr>
                    <th>Ultsavam</th>
                    <th>Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>


                <tbody>
                  {FinalSubmissionList
                    .filter((item) => item.sakha === selectedSakha)
                    .map((item) => (
                      <tr key={item.sakha}>
                        <td>{item.sakha}</td>

                        <td>
                          ₹ {Number(item.amount || 0).toLocaleString("en-IN")}
                        </td>

                        <td>
                          <Button
                            className="tbnewbtn already_finalized"
                            onClick={() => {
                              setSakhaSubmitted(item.sakha);
                              handleFinalize();
                            }}
                            disabled={item.isSubmitted}
                          >
                            {item.isSubmitted ? "Already Finalized" : "Finalize"}
                          </Button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>


              <Button className="tbnewbtncl" onClick={handleCloseModal}>Close</Button>

              <p className="newmodalheadp">ശ്രദ്ധിക്കുക!.</p>
              <p className="newmodalp">ഓരോ ശാഖയുടെയും തുക പരിശോധിച്ച് ഉറപ്പുവരുത്തിയതിനു ശേഷം മാത്രം FINALIZE ചെയ്യുക.
                FINALIZE ചെയ്‌തു കഴിഞ്ഞ ശാഖ യുടെ ഗുരുദക്ഷിണ ലിസ്റ്റിൽ താങ്കൾക്ക് മാറ്റം വരുത്താൻ സാധിക്കുകയില്ല.</p>
            </center>
          </div>
        </Modal.Body>
      </Modal>


      <Modal show={ShowFinalConfirmModal} onHide={handleCloseSecondModal} centered>
        {/* <Modal.Header closeButton>
    <Modal.Title>Finalize Confirmation</Modal.Title>
  </Modal.Header> */}
        <Modal.Body>
          <div className="modstyle">
            <center>
              <h6>Do you want to finalize <span className="colorChange">{selectedSakha}</span>?</h6>
              <p className="newmodalp2">FINALIZE ചെയ്ത്‌തു കഴിഞ്ഞ ശാഖ യുടെ ഗുരുദക്ഷിണ ലിസ്റ്റിൽ താങ്കൾക്ക് മാറ്റം വരുത്താൻ സാധിക്കുകയില്ല.</p>

              <Button className="newbtn2" onClick={handleCloseSecondModal}>
                No
              </Button>
              <Button className="newbtn" onClick={finalSubmit}>
                Yes
              </Button>
            </center>
          </div>

        </Modal.Body>
        {/* <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseSecondModal}>
      Cancel
    </Button>
    <Button variant="success" onClick={() => {
      handleCloseSecondModal();
      handleRedirect(); // or your finalize logic
    }}>
      Confirm
    </Button>
  </Modal.Footer> */}
      </Modal>


      <TopBar />




      <Modal
        show={showAddModal}
        onHide={handleCloseAddModal}
        size="xl"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          {/* <pre
                              style={{
                                  whiteSpace: "pre-wrap",
                                  background: "#f8f9fa",
                                  padding: "10px",
                                  border: "1px solid #ddd",
                                  borderRadius: "5px",
                                  color: "green"
                              }}
                          >
                              {submittedData}
                          </pre> */}
          <Modal.Title>
            <center>
              <h5 className="newraphead">
                Add Gurudakshina for{" "}
                <span className="newspanz">{selectedSakha}</span>{" "}
                Ultsavam at{" "}
                <span className="newspanz">{selectedSthanName}</span> Sthan
              </h5>
            </center>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form>


            <Row>

              <Col md={6}>
                {/* <div className="position-relative"> */}
                <div className="input-box arthik_input-box">
                  <Form.Label className="newformstyle label2">Name</Form.Label>
                  <input
                    type="text"
                    id="name"
                    className="newinpstyle"
                    placeholder="Enter Name"
                    autoComplete="off"
                    ref={nameRef}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />

                  {showNameSuggestions && nameSuggestions.length > 0 && (
                    <ul
                      className="list-group position-absolute w-100"
                      style={{
                        zIndex: 1000,
                        maxHeight: "250px",
                        overflowY: "auto",
                      }}
                    >
                      {nameSuggestions.map((item) => (
                        <li
                          key={item.id}
                          className="list-group-item list-group-item-action"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setName(item.name);
                            setMobile(item.mobile || "");
                            setAge("");
                            setHouse_name(item.house_name || "");
                            setPostOffice(item.post_office || "");
                            setPincode(item.pincode || "");
                            setPan(item.pan || "");
                            // setIsStudent(!!item.vidyarthi);
                            // setSelectedShreni(item.shreni)
                            setIsPrathyajithVolunteer(item.oauth_taken);

                            setGurudakshinaId(item.id);


                            setShowNameSuggestions(false);
                          }}
                        >
                          <strong>{item.name}</strong>
                          {item.mobile && (
                            <div className="text-muted small">{item.mobile}</div>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}

                  {submitted && !name.trim() && (
                    <small className="text-danger"
                      style={{ fontSize: "12px" }}>Name is required.</small>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="input-box arthik_input-box">
                  <Form.Label className="newformstyle label2">Samarppan Date</Form.Label>
                  <input
                    disabled={Finilized}
                    type="date"
                    id="date"
                    className="newinpstyle"
                    onChange={(e) => setOriginalDate(e.target.value)}
                    value={originalDate}
                    required
                  />

                  {submitted && !originalDate && (
                    <small className="text-danger"
                      style={{ fontSize: "12px" }}>Date is required.</small>
                  )}
                </div>
              </Col>



              <Col md={6}>
                <div className="input-box arthik_input-box">
                  <Form.Label className="newformstyle label2">House name</Form.Label>
                  <input
                    disabled={Finilized}
                    type="text"
                    id="house_name"
                    className="newinpstyle"
                    placeholder="Enter House name"
                    autoComplete="off"
                    onChange={(e) => setHouse_name(e.target.value)}
                    value={house_name}
                    required
                  />
                  {submitted && !house_name.trim() && (
                    <small className="text-danger"
                      style={{ fontSize: "12px" }}>House name is required.</small>
                  )}
                </div>
              </Col>

              {/* ---- Ultsavam ---- */}
              {/* <Col md={6}>
                                      
                                      <div className="input-box arthik_input-box">
                                          <select
                                              id="sakhaSelect"
                                              className="form-control guruselect"
                                              value={selectedPopupSakha}
                                              onChange={handleSakhaChange}
                                          >
                                              <option value="">-- Select Ultsavam --</option>
                                              {sakhaList.map((sakha, index) => (
                                                  <option key={index} value={sakha}>
                                                      {sakha}
                                                  </option>
                                              ))}
                                          </select>
      
                                          {sakhaWarning && (
                                              <small className="text-danger mt-1">
                                                  {selectedPopupSakha} Finalized
                                              </small>
                                          )}
                                          {submitted && !selectedPopupSakha && (
                                              <small className="text-danger"
                                                  style={{ fontSize: "12px" }}>Please select Ultsavam.</small>
                                          )}
                                      </div>
                                  </Col> */}

              {/* ---- Shreni ---- */}

              <Col md={2}>
                <div className="input-box arthik_input-box">
                  <Form.Label className="newformstyle label2">Age</Form.Label>
                  <input
                    disabled={Finilized}
                    // type="tel"
                    id="age"
                    className="telstyle newinpstyle"
                    placeholder="Age"
                    autoComplete="off"

                    // onChange={(e) => {
                    //     const value = e.target.value.replace(/\D/g, "");

                    //     setAge(value);

                    //     if (value) {
                    //         setSelectedShreni(getShreni(value));
                    //         updateStudentStatus(value);
                    //     } else {
                    //         setSelectedShreni("");
                    //         updateStudentStatus("");
                    //     }
                    // }}

                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, "").slice(0, 3);

                      // Don't allow values greater than 110
                      if (value && Number(value) > 110) {
                        value = "110";
                      }

                      setAge(value);

                      if (value && Number(value) > 0) {
                        setSelectedShreni(getShreni(value));
                        updateStudentStatus(value);
                      } else {
                        setSelectedShreni("");
                        updateStudentStatus("");
                      }
                    }}
                    value={age}
                    required
                    disabled={Finilized}
                  />

                  {submitted && !age && (
                    <small
                      className="text-danger"
                      style={{ fontSize: "11px" }}
                    >
                      Age must be between 1 & 110.
                    </small>
                  )}
                </div>
              </Col>
              <Col md={2}>
                <Form.Label className="newformstyle label2"></Form.Label>
                <div className="form-check madhu">
                  <input
                    type="checkbox"
                    id="isStudent"
                    className="form-check-input madhu2"
                    checked={isStudent}
                    disabled={studentDisabled || Finilized}
                    onChange={(e) => setIsStudent(e.target.checked)}
                  />
                  <label className="form-check-label studentClass" htmlFor="isStudent">
                    Student
                  </label>
                </div>
              </Col>
              <Col md={2}>
                <Form.Label className="newformstyle label2">Shreni</Form.Label>
                <div className="input-box arthik_input-box">
                  <select
                    id="shreniSelect"
                    className="form-control guruselect"
                    value={selectedShreni}
                    onChange={(e) => setSelectedShreni(e.target.value)}
                    // disabled={Finilized}
                    disabled
                  >
                    <option value="">-- Shreni --</option>
                    {shreniList.map((shreni, index) => (
                      <option key={index} value={shreni}>
                        {shreni}
                      </option>
                    ))}
                  </select>

                  {submitted && !selectedShreni && (
                    <small className="text-danger"
                      style={{ fontSize: "12px" }}>Shreni is required.</small>
                  )}
                </div>
              </Col>

              {/* ALL OTHER FIELDS HERE */}
              {/* Name, Mobile, Amount, PAN, Payment Mode, House Name, etc. */}


              <Col md={6}>
                <div className="input-box arthik_input-box">
                  <Form.Label className="newformstyle label2">Mobile Number</Form.Label>
                  <input
                    disabled={Finilized}
                    type="tel"
                    id="mobile"
                    className="telstyle newinpstyle"
                    placeholder="Enter Mobile number"
                    autoComplete="off"
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                      setMobile(value);
                    }}
                    value={mobile}
                    required
                    aria-invalid={validMobile ? "false" : "true"}
                    aria-describedby="namenote"
                    onFocus={() => setMobileFocus(true)}
                    onBlur={() => setMobileFocus(false)}
                  />

                  {submitted && !mobile && (
                    <small className="text-danger"
                      style={{ fontSize: "12px" }}>Mobile number is required.</small>
                  )}
                </div>

              </Col>
              <Col md={6}>

                <div className="input-box arthik_input-box">
                  <Form.Label className="newformstyle label2">Amount</Form.Label>
                  <input
                    disabled={Finilized}
                    type="text"
                    id="amount"
                    className="newinpstyle"
                    placeholder="Enter Amount"
                    autoComplete="off"
                    ref={amountRef}
                    onChange={(e) => {
                      let value = e.target.value;

                      // Allow only numbers and one decimal point
                      value = value.replace(/[^0-9.]/g, "");

                      // Allow only one decimal point
                      const parts = value.split(".");
                      if (parts.length > 2) {
                        value = parts[0] + "." + parts[1];
                      }

                      // Limit integer part to 7 digits
                      if (parts[0].length > 7) {
                        parts[0] = parts[0].slice(0, 7);
                        value = parts[1] !== undefined ? `${parts[0]}.${parts[1]}` : parts[0];
                      }

                      setAmount(value);
                    }}
                    value={amount}
                    required
                    aria-describedby="amountnote"
                    onFocus={() => setAmountFocus(true)}
                    onBlur={() => setAmountFocus(false)}
                  />

                  {submitted && !amount && (
                    <small className="text-danger"
                      style={{ fontSize: "12px" }}>Amount is required.</small>
                  )}
                </div>
              </Col>

              {parseFloat(amount) > 1999 && (
                <Col md={6}>
                  <div className="input-box arthik_input-box">
                    <Form.Label className="newformstyle label2">PAN</Form.Label>
                    <input
                      disabled={Finilized}
                      type="text"
                      id="pan"
                      className="newinpstyle"
                      placeholder="Enter PAN"
                      autoComplete="off"
                      maxLength={10}
                      onChange={(e) => setPan(e.target.value.toUpperCase())}
                      value={pan}
                    />
                  </div>
                  {submitted && parseFloat(amount) > 1999 && !pan.trim() && (
                    <small className="text-danger"
                      style={{ fontSize: "12px" }}>PAN is required.</small>
                  )}
                </Col>
              )}
              {/* 
                    <Col md={6}>
                      <div className="input-box arthik_input-box">
                        <select
                          disabled={Finilized}
                          id="shrenSelect"
                          className="form-control guruselect"
                          value={selectedPaymentMode}
                          onChange={(e) => setSelectedPaymentMode(e.target.value)}
                        >
                          <option value="">-- Select Payment Mode --</option>
                          {paymentModeList.map((paymentMode, index) => (
                            <option key={index} value={paymentMode}>
                              {paymentMode}
                            </option>
                          ))}
                        </select>
      
                        {error && <p style={{ color: 'red' }}>{error}</p>}
                      </div>
                    </Col> */}
              <Col md={2}>
                <div className="form-check madhu">
                  <Form.Label className="newformstyle label2"></Form.Label>
                  <input
                    type="checkbox"
                    id="paymentMode"
                    className="form-check-input madhu2"
                    checked={isCheque}
                    disabled={Finilized}
                    onChange={(e) => setIsCheque(e.target.checked)}
                  />
                  <label className="form-check-label prathyajithClass" htmlFor="paymentMode">
                    Cheque
                  </label>
                </div>
              </Col>

              {/* {selectedPaymentMode === "Cheque" && ( */}

              <Col md={2}>
                {isCheque && (

                  <div className="input-box arthik_input-box">
                    <Form.Label className="newformstyle label2">Bank name</Form.Label>
                    <input
                      disabled={Finilized}
                      type="text"
                      id="bankSelect"
                      className="newinpstyle"
                      placeholder="Enter Bank name"
                      autoComplete="off"
                      onChange={(e) => setSelectedBank(e.target.value)}
                      value={selectedBank}

                      required
                      aria-describedby="namenote"
                      onFocus={() => setChequeNoFocus(true)}
                      onBlur={() => setChequeNoFocus(false)}
                    />
                    {submitted && isCheque && !selectedBank.trim() && (
                      <small className="text-danger"
                        style={{ fontSize: "12px" }}>Bank name is required.</small>
                    )}
                  </div>
                )}
              </Col>

              <Col md={2}>
                {isCheque && (
                  <div className="input-box arthik_input-box">
                    <Form.Label className="newformstyle label2">Cheque number</Form.Label>
                    <input
                      disabled={Finilized}
                      type="text"
                      id="cheque_no"
                      className="newinpstyle"
                      placeholder="Enter Cheque no"
                      autoComplete="off"
                      ref={chequeNoRef}
                      maxLength={20}
                      onChange={(e) => setChequeNo(e.target.value)}
                      value={chequeNo}
                      required
                      aria-invalid={validChequeNo ? "false" : "true"}
                      aria-describedby="namenote"
                      onFocus={() => setChequeNoFocus(true)}
                      onBlur={() => setChequeNoFocus(false)}
                    />
                    {submitted && isCheque && !chequeNo.trim() && (
                      <small className="text-danger"
                        style={{ fontSize: "12px" }}>Enter Cheque number.</small>
                    )}
                  </div>

                )}
              </Col>





              {house_name.trim() !== "" && (
                <Col md={6}>
                  <Form.Label className="newformstyle label2">Pincode</Form.Label>
                  <div className="input-box arthik_input-box">
                    <input
                      disabled={Finilized}
                      type="text"
                      id="pincode"
                      className="newinpstyle"
                      placeholder="Enter Pincode"
                      autoComplete="off"
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");

                        if (value.length <= 6) {
                          setPincode(value);
                          searchPincode(value);
                        }
                      }}
                      value={pincode}
                      inputMode="numeric"
                      maxLength={6}
                    />

                    {showPincodeDropdown && pincodeSuggestions.length > 0 && (
                      <div className="dropdown-menu show w-100">

                        {pincodeSuggestions.map((item, index) => (
                          <button
                            type="button"
                            key={index}
                            className="dropdown-item"
                            onClick={() => {
                              setPincode(item.pincode);
                              setPostOffice(item.officename);
                              setShowPincodeDropdown(false);
                            }}
                          >
                            <strong>{item.pincode}</strong> - {item.officename}
                            <br />
                            <small>{item.district}</small>
                          </button>
                        ))}

                      </div>
                    )}
                  </div>
                  {submitted && !pincode.trim() && (
                    <small className="text-danger"
                      style={{ fontSize: "12px" }}>
                      Pincode is required.
                    </small>
                  )}
                </Col>
              )}



              {house_name.trim() !== "" && (
                <Col md={6}>
                  <div className="input-box arthik_input-box">
                    <Form.Label className="newformstyle label2">Post office</Form.Label>
                    <input
                      disabled={Finilized}
                      type="text"
                      id="post_office"
                      className="newinpstyle"
                      placeholder="Enter Post office"
                      autoComplete="off"
                      onChange={(e) => {
                        const value = e.target.value;
                        setPostOffice(value);
                        searchPostOffice(value);
                      }}
                      value={postOffice}
                    />
                    {showPostOfficeDropdown && postOfficeSuggestions.length > 0 && (
                      <div className="dropdown-menu show w-100">

                        {postOfficeSuggestions.map((item, index) => (
                          <button
                            type="button"
                            key={index}
                            className="dropdown-item"
                            onClick={() => {
                              setPostOffice(item.officename);
                              setPincode(item.pincode);
                              setShowPostOfficeDropdown(false);
                            }}
                          >
                            <strong>{item.officename}</strong>
                            <br />
                            <small>
                              {item.pincode} • {item.district}
                            </small>
                          </button>
                        ))}

                      </div>
                    )}
                  </div>
                  {submitted && !postOffice.trim() && (
                    <small className="text-danger"
                      style={{ fontSize: "12px" }}>
                      Post office is required.
                    </small>
                  )}
                </Col>
              )}


              {Number(age) >= 18 && (
                <Col md={12}>
                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      id="isPrathyajithVolunteer"
                      className="form-check-input madhu3"
                      checked={isPrathyajithVolunteer}
                      onChange={(e) => setIsPrathyajithVolunteer(e.target.checked)}
                      disabled={Finilized}
                    />
                    <label
                      className="form-check-label prathyajithClass"
                      htmlFor="isPrathyajithVolunteer"
                    >
                      Prathinjith swayamsevak
                    </label>
                  </div>
                </Col>
              )}

            </Row>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button

            className="btn btn-secondary newviewbtn2"
            onClick={handleCloseAddModal}
          >
            Close
          </button>

          <button

            className="btn btn-warning newviewbtn2"
            // onClick={handleSubmit}
            onClick={(e) =>
              gurudakshinaId ? handleEditSubmit(e) : handleSubmit(e)
            }
            disabled={
              // !validName ||
              // !selectedPopupSakha ||
              // !selectedShreni ||
              // !selectedPaymentMode ||
              // !originalDate ||
              // !house_name ||
              Finilized
            }
          >
            Add Gurudakshina
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminListGurudakshinaInSthan;
